import { TaxRulesGridView } from '~/components/prices/tax-rules';
import { PageContainer } from '~/components/page-container';

export function TaxRules() {
	return (
		<PageContainer>
			<TaxRulesGridView />
		</PageContainer>
	);
}
